export default __webpack_public_path__ + "static/media/img12.aaf58d64.png";